export function arrayToRecord<T>(arr: T[], key = 'id') {
  if (!arr?.length) return {} as Record<string, T>
  return arr.reduce((ret, data) => {
    ret[data[key]] = data
    return ret
  }, {} as Record<string, T>)
}
